// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Google Banana 图片生成节点样式 */

.GoogleBananaNode-container {
  position: relative;
  background: linear-gradient(135deg, #fff9e6 0%, #ffffff 100%);
  border: 2px solid #ffd700;
  border-radius: 12px;
  padding: 16px;
  min-width: 320px;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.2);
  transition: box-shadow 0.3s ease;
}

.GoogleBananaNode-container:hover {
  box-shadow: 0 4px 16px rgba(255, 215, 0, 0.3);
}

.GoogleBananaNode-title {
  font-size: 13px;
  font-weight: 700;
  color: #ff8c00;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
  font-family: monospace;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

/* 模式徽章 */
.GoogleBananaNode-mode-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.GoogleBananaNode-mode-t2i {
  background: #e3f2fd;
  color: #1976d2;
  border: 1px solid #90caf9;
}

.GoogleBananaNode-mode-i2i {
  background: #e8f5e9;
  color: #388e3c;
  border: 1px solid #81c784;
}

.GoogleBananaNode-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 字段 */
.GoogleBananaNode-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.GoogleBananaNode-label {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

/* 按钮组 */
.GoogleBananaNode-button-group {
  display: flex;
  gap: 8px;
}

.GoogleBananaNode-button {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #333;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.GoogleBananaNode-button:hover:not(:disabled) {
  border-color: #ffa500;
  color: #ffa500;
}

.GoogleBananaNode-button-active {
  background: linear-gradient(135deg, #ffa500 0%, #ff8c00 100%);
  color: white;
  border-color: #ffa500;
}

.GoogleBananaNode-button:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

/* 下拉选择 */
.GoogleBananaNode-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.GoogleBananaNode-select:focus {
  outline: none;
  border-color: #ffa500;
}

.GoogleBananaNode-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

/* 信息区域 */
.GoogleBananaNode-info {
  padding: 10px;
  background: linear-gradient(135deg, #fffbf0 0%, #fff 100%);
  border-radius: 8px;
  border: 1px solid #ffe4b3;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.GoogleBananaNode-info-item {
  font-size: 11px;
  color: #ff8c00;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 提示信息 */
.GoogleBananaNode-hint {
  font-size: 11px;
  color: #999;
  line-height: 1.4;
  padding: 8px;
  background-color: #f9fafb;
  border-radius: 6px;
}

/* 生成按钮 */
.GoogleBananaNode-generate {
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #ffa500 0%, #ff8c00 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(255, 165, 0, 0.3);
}

.GoogleBananaNode-generate:hover:not(.GoogleBananaNode-generate-disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 165, 0, 0.4);
}

.GoogleBananaNode-generate:active:not(.GoogleBananaNode-generate-disabled) {
  transform: translateY(0);
}

.GoogleBananaNode-generate-disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* 错误提示 */
.GoogleBananaNode-error {
  padding: 10px 12px;
  background-color: #fee;
  color: #c33;
  border-radius: 6px;
  font-size: 12px;
  border-left: 3px solid #c33;
}

/* Handle 样式 */
.GoogleBananaNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid #ffa500;
  background: white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.GoogleBananaNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

/* 不同类型的 Handle 颜色区分 */
.GoogleBananaNode-handle-prompt {
  border-color: #667eea;
  background: #667eea;
}

.GoogleBananaNode-handle-image {
  border-color: #48bb78;
  background: #48bb78;
}

.GoogleBananaNode-handle-output {
  border-color: #ffa500;
  background: #ffa500;
}

/* Handle 标签 */
.GoogleBananaNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #ffa500 0%, #ff8c00 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(255, 165, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

/* 可点击的 Handle 标签 */
.GoogleBananaNode-handle-label-clickable {
  pointer-events: auto;  /* 改为可交互 */
  cursor: pointer;       /* 显示手型光标 */
  user-select: none;     /* 禁止文本选择 */
}

/* 可点击标签的悬停效果 */
.GoogleBananaNode-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(255, 165, 0, 0.45);
  background: linear-gradient(135deg, #ffb733 0%, #ff9f1a 100%);
}

/* 可点击标签的按下效果 */
.GoogleBananaNode-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

/* 添加点击提示图标 */
.GoogleBananaNode-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.GoogleBananaNode-handle-label-clickable:hover::after {
  opacity: 1;
}

/* 悬停时显示标签 */
.GoogleBananaNode-handle:hover .GoogleBananaNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(255, 165, 0, 0.35);
}

.GoogleBananaNode-handle:hover .GoogleBananaNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #ffa500;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(255, 165, 0, 0.2));
}

.GoogleBananaNode-handle-prompt .GoogleBananaNode-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.GoogleBananaNode-handle-prompt:hover .GoogleBananaNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.GoogleBananaNode-handle-prompt:hover .GoogleBananaNode-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

.GoogleBananaNode-handle-image .GoogleBananaNode-handle-label {
  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);
}

.GoogleBananaNode-handle-image:hover .GoogleBananaNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

.GoogleBananaNode-handle-image:hover .GoogleBananaNode-handle-label::before {
  border-left-color: #48bb78;
  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .GoogleBananaNode-handle .GoogleBananaNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(255, 165, 0, 0.35);
}

.react-flow__node.selected .GoogleBananaNode-handle-prompt .GoogleBananaNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.react-flow__node.selected .GoogleBananaNode-handle-image .GoogleBananaNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

/* 标签出现动画 */
@keyframes GoogleBananaNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.GoogleBananaNode-handle:hover .GoogleBananaNode-handle-label,
.react-flow__node.selected .GoogleBananaNode-handle .GoogleBananaNode-handle-label {
  animation: GoogleBananaNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 连接状态显示 */
.GoogleBananaNode-status {
  margin-bottom: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.GoogleBananaNode-status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.GoogleBananaNode-status-item:not(:last-child) {
  border-bottom: 1px dashed #e5e7eb;
  margin-bottom: 6px;
  padding-bottom: 8px;
}

.GoogleBananaNode-status-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}

.GoogleBananaNode-status-value {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.GoogleBananaNode-status-connected {
  color: #10b981;
  background: #d1fae5;
  border: 1px solid #10b981;
}

.GoogleBananaNode-status-disconnected {
  color: #ef4444;
  background: #fee2e2;
  border: 1px solid #ef4444;
}

/* 复制按钮 */
.GoogleBananaNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ffd700;
  border-radius: 6px;
  background: white;
  color: #ff8c00;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(255, 165, 0, 0.2);
}

.GoogleBananaNode-container:hover .GoogleBananaNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.GoogleBananaNode-duplicate-button:hover {
  background: #fffbf0;
  border-color: #ffa500;
  color: #ff8c00;
  transform: scale(1.05);
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/GoogleBananaNode.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,OAAO;AACP;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,0DAA0D;EAC1D,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,SAAS;AACT;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,8CAA8C;EAC9C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,oBAAoB,GAAG,UAAU;EACjC,eAAe,QAAQ,WAAW;EAClC,iBAAiB,MAAM,WAAW;AACpC;;AAEA,eAAe;AACf;EACE,wDAAwD;EACxD,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA,eAAe;AACf;EACE,wDAAwD;AAC1D;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,UAAU;EACV,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,yEAAyE;AAC3E;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB","sourcesContent":["/* Google Banana 图片生成节点样式 */\n\n.GoogleBananaNode-container {\n  position: relative;\n  background: linear-gradient(135deg, #fff9e6 0%, #ffffff 100%);\n  border: 2px solid #ffd700;\n  border-radius: 12px;\n  padding: 16px;\n  min-width: 320px;\n  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.2);\n  transition: box-shadow 0.3s ease;\n}\n\n.GoogleBananaNode-container:hover {\n  box-shadow: 0 4px 16px rgba(255, 215, 0, 0.3);\n}\n\n.GoogleBananaNode-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #ff8c00;\n  margin-bottom: 12px;\n  letter-spacing: 0.5px;\n  font-family: monospace;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n/* 模式徽章 */\n.GoogleBananaNode-mode-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.GoogleBananaNode-mode-t2i {\n  background: #e3f2fd;\n  color: #1976d2;\n  border: 1px solid #90caf9;\n}\n\n.GoogleBananaNode-mode-i2i {\n  background: #e8f5e9;\n  color: #388e3c;\n  border: 1px solid #81c784;\n}\n\n.GoogleBananaNode-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* 字段 */\n.GoogleBananaNode-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.GoogleBananaNode-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* 按钮组 */\n.GoogleBananaNode-button-group {\n  display: flex;\n  gap: 8px;\n}\n\n.GoogleBananaNode-button {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #333;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.GoogleBananaNode-button:hover:not(:disabled) {\n  border-color: #ffa500;\n  color: #ffa500;\n}\n\n.GoogleBananaNode-button-active {\n  background: linear-gradient(135deg, #ffa500 0%, #ff8c00 100%);\n  color: white;\n  border-color: #ffa500;\n}\n\n.GoogleBananaNode-button:disabled {\n  background-color: #f5f5f5;\n  color: #999;\n  cursor: not-allowed;\n}\n\n/* 下拉选择 */\n.GoogleBananaNode-select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background-color: white;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.GoogleBananaNode-select:focus {\n  outline: none;\n  border-color: #ffa500;\n}\n\n.GoogleBananaNode-select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n/* 信息区域 */\n.GoogleBananaNode-info {\n  padding: 10px;\n  background: linear-gradient(135deg, #fffbf0 0%, #fff 100%);\n  border-radius: 8px;\n  border: 1px solid #ffe4b3;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.GoogleBananaNode-info-item {\n  font-size: 11px;\n  color: #ff8c00;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* 提示信息 */\n.GoogleBananaNode-hint {\n  font-size: 11px;\n  color: #999;\n  line-height: 1.4;\n  padding: 8px;\n  background-color: #f9fafb;\n  border-radius: 6px;\n}\n\n/* 生成按钮 */\n.GoogleBananaNode-generate {\n  width: 100%;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #ffa500 0%, #ff8c00 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(255, 165, 0, 0.3);\n}\n\n.GoogleBananaNode-generate:hover:not(.GoogleBananaNode-generate-disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 165, 0, 0.4);\n}\n\n.GoogleBananaNode-generate:active:not(.GoogleBananaNode-generate-disabled) {\n  transform: translateY(0);\n}\n\n.GoogleBananaNode-generate-disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* 错误提示 */\n.GoogleBananaNode-error {\n  padding: 10px 12px;\n  background-color: #fee;\n  color: #c33;\n  border-radius: 6px;\n  font-size: 12px;\n  border-left: 3px solid #c33;\n}\n\n/* Handle 样式 */\n.GoogleBananaNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #ffa500;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.GoogleBananaNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n/* 不同类型的 Handle 颜色区分 */\n.GoogleBananaNode-handle-prompt {\n  border-color: #667eea;\n  background: #667eea;\n}\n\n.GoogleBananaNode-handle-image {\n  border-color: #48bb78;\n  background: #48bb78;\n}\n\n.GoogleBananaNode-handle-output {\n  border-color: #ffa500;\n  background: #ffa500;\n}\n\n/* Handle 标签 */\n.GoogleBananaNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #ffa500 0%, #ff8c00 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(255, 165, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n/* 可点击的 Handle 标签 */\n.GoogleBananaNode-handle-label-clickable {\n  pointer-events: auto;  /* 改为可交互 */\n  cursor: pointer;       /* 显示手型光标 */\n  user-select: none;     /* 禁止文本选择 */\n}\n\n/* 可点击标签的悬停效果 */\n.GoogleBananaNode-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(255, 165, 0, 0.45);\n  background: linear-gradient(135deg, #ffb733 0%, #ff9f1a 100%);\n}\n\n/* 可点击标签的按下效果 */\n.GoogleBananaNode-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n/* 添加点击提示图标 */\n.GoogleBananaNode-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.GoogleBananaNode-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n/* 悬停时显示标签 */\n.GoogleBananaNode-handle:hover .GoogleBananaNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(255, 165, 0, 0.35);\n}\n\n.GoogleBananaNode-handle:hover .GoogleBananaNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #ffa500;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(255, 165, 0, 0.2));\n}\n\n.GoogleBananaNode-handle-prompt .GoogleBananaNode-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.GoogleBananaNode-handle-prompt:hover .GoogleBananaNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.GoogleBananaNode-handle-prompt:hover .GoogleBananaNode-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n.GoogleBananaNode-handle-image .GoogleBananaNode-handle-label {\n  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);\n}\n\n.GoogleBananaNode-handle-image:hover .GoogleBananaNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n.GoogleBananaNode-handle-image:hover .GoogleBananaNode-handle-label::before {\n  border-left-color: #48bb78;\n  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .GoogleBananaNode-handle .GoogleBananaNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(255, 165, 0, 0.35);\n}\n\n.react-flow__node.selected .GoogleBananaNode-handle-prompt .GoogleBananaNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.react-flow__node.selected .GoogleBananaNode-handle-image .GoogleBananaNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes GoogleBananaNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.GoogleBananaNode-handle:hover .GoogleBananaNode-handle-label,\n.react-flow__node.selected .GoogleBananaNode-handle .GoogleBananaNode-handle-label {\n  animation: GoogleBananaNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 连接状态显示 */\n.GoogleBananaNode-status {\n  margin-bottom: 12px;\n  padding: 12px;\n  background: #f9fafb;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.GoogleBananaNode-status-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 0;\n}\n\n.GoogleBananaNode-status-item:not(:last-child) {\n  border-bottom: 1px dashed #e5e7eb;\n  margin-bottom: 6px;\n  padding-bottom: 8px;\n}\n\n.GoogleBananaNode-status-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.GoogleBananaNode-status-value {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.GoogleBananaNode-status-connected {\n  color: #10b981;\n  background: #d1fae5;\n  border: 1px solid #10b981;\n}\n\n.GoogleBananaNode-status-disconnected {\n  color: #ef4444;\n  background: #fee2e2;\n  border: 1px solid #ef4444;\n}\n\n/* 复制按钮 */\n.GoogleBananaNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ffd700;\n  border-radius: 6px;\n  background: white;\n  color: #ff8c00;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(255, 165, 0, 0.2);\n}\n\n.GoogleBananaNode-container:hover .GoogleBananaNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.GoogleBananaNode-duplicate-button:hover {\n  background: #fffbf0;\n  border-color: #ffa500;\n  color: #ff8c00;\n  transform: scale(1.05);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
